import Vue from 'vue'
import { Message, FormItem, Input,
        Dialog, Form,Option,MessageBox, Carousel, carouselItem,
        Checkbox, Drawer} from 'element-ui'

Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Carousel)
Vue.use(carouselItem)
// Vue.use(Container)
// Vue.use(Header)
// Vue.use(Aside)
// Vue.use(Main)
// Vue.use(Menu)
// Vue.use(Submenu)
// Vue.use(MenuItem)
// Vue.use(Breadcrumb)
// Vue.use(BreadcrumbItem)
// Vue.use(Card)
// Vue.use(Row)
// Vue.use(Col)
// Vue.use(Table)
// Vue.use(TableColumn)
// Vue.use(Switch)
// Vue.use(Tooltip)
// Vue.use(Pagination)
Vue.use(Dialog)
// Vue.use(Tag)
// Vue.use(Tree)
// Vue.use(Select)
Vue.use(Option)
// Vue.use(Cascader)
// Vue.use(Alert)
// Vue.use(Tabs)
// Vue.use(TabPane)
// Vue.use(Steps)
// Vue.use(Step)
// Vue.use(CheckboxGroup)
Vue.use(Checkbox)
// Vue.use(Upload)
// Vue.use(Timeline)
// Vue.use(TimelineItem)
Vue.use(Drawer)
// 这个特殊的是message, 需要全局挂载  弹窗
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
